import {Component, OnDestroy, OnInit} from '@angular/core';
import {Document} from '../../../types/document-data.types';
import {ApiClientService} from '../../../services/api-client.service';
import {DirectoryService} from '../../../services/directory.service';
import {DocumentsService} from '../../../services/documents.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {Subject} from 'rxjs/Subject';
import {takeUntil} from 'rxjs/operators';

declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'documents-detailed-view',
    templateUrl: './documents-detailed-view.component.html',
    styleUrls: ['./documents-detailed-view.component.scss']
})

export class DocumentsDetailedViewComponent implements OnInit, OnDestroy {
    public data: ItemObj = new ItemObj();
    disabledFileInput = false;
    navPosition = 'details';
    attachments: Array<any> = [];
    selectValues = [
        {name: 'day', displayName: 'Per Day'},
        {name: 'week', displayName: 'Per Week'},
        {name: 'month', displayName: 'Per Month'},
        {name: 'year', displayName: 'Per Year'}
    ];
    noEdit = false;

    public buildings: Array<any> = [];
    public corporationNumbers: Array<any> = [];
    public isCorporationLoading: boolean = false;
    private ngUnsubscribe = new Subject();
    haveaParent = false;
    acceptableFrom: Date;
    acceptableTo: Date;

    constructor(public api: ApiClientService,
                public ds: DocumentsService,
                public directoryService: DirectoryService,
                public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        const selectedItemDataCheckInterval = setInterval(() => {
            if (this.ds.selectedItemData) {
                if (this.ds.selectedItemData.acceptableFrom) {
                    this.acceptableFrom = new Date(this.ds.selectedItemData.acceptableFrom.valueOf());
                }
                if (this.ds.selectedItemData.acceptableTo) {
                    this.acceptableTo = new Date(this.ds.selectedItemData.acceptableTo.valueOf());
                }
                clearInterval(selectedItemDataCheckInterval);
            }
        }, 10); // yes, I am not proud of this solution, but lets be real, there are way worse solutions around here...
        this.ds.corporationsListLoaded
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
                if (data) {
                    this.getCorporationNumberList();
                } else {
                    this.isCorporationLoading = true;
                }
            });
    }

    onSubmit(data: any): void {
        this.noEdit = true;
        const url = `/v1/parcel-service-settings/${this.ds.selectedItemData.corporationNumberBd}.json`;
        this.ds.api.patch('domainParcels', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => {
                if (JSON.parse(error._body).errors && JSON.parse(error._body).errors.length > 0)
                    JSON.parse(error._body).errors.filter(error => toastr.error(error.description));
                else
                    toastr.error('Update failed!');
            },
            () => {
                this.noEdit = false;
            }
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        // this.settingsParcelsService.toggleDetailedView(this.settingsParcelsService.selectedItemData, true);
        // this.settingsParcelsService.getData();
        if (close) this.ds.toggleDetailedView(null);
    }

    applyChanges(item, form, changedValue, formField) {
        let valueToSend = changedValue;
        if (changedValue.shareContact === 'true')
            valueToSend.shareContact = 1;
        else if (changedValue.shareContact === 'false')
            valueToSend.shareContact = 0;

        if (changedValue.requestType) {
            if (changedValue.requestType.length == 1 && changedValue.requestType != '0')
                valueToSend = {serviceRequestType: changedValue.requestType};
            else
                valueToSend = {serviceRequestTypeOther: changedValue.requestType};
        }

        if (form.dirty) {
            item[formField] = form.value[formField];
            this.onSubmit(valueToSend);
        }
    }

    public validateValue(event) {
        return event.charCode >= 48 && event.charCode <= 57;
    }

    public transformSize(bytes) {
        if (bytes) {
            const thresh = 1024;
            if (Math.abs(bytes) < thresh) {
                return bytes + ' B';
            }

            const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            let u = -1;
            do {
                bytes /= thresh;
                ++u;
            } while (Math.abs(bytes) >= thresh && u < units.length - 1);

            return bytes.toFixed(1) + ' ' + units[u];
        } else
            return '-';
    }

    public submitData(data?) {
        if (!this.ds.selectedItemData.corporationNumbers.length)
            toastr.warning('Corporation Numbers should not be blank.');
        else if (!this.ds.selectedItemData.buildings.length)
            toastr.warning('Buildings should not be blank.');
        else {
            if (data) {
                this.update(data);
            } else {
                this.update(this.ds.getCorporationBuildingsData());
            }
        }
    }

    update(data) {
        this.ds.update(data);
    }

    getBuildingsForSelectedCorporations(event?, eventType?) {
        this.buildings = [];

        if (!this.haveaParent && this.data.corporationNumbers.length) {
            this.data.corporationNumbers.forEach(corp => {
                this.ds.buildingsForUpdate.forEach(building => {
                    if ((<any>building).corporationNumber == corp.id)
                        this.buildings.push({
                            ...building,
                            itemName: building.name,
                        });
                });
            });
        } else if (this.haveaParent && this.data.corporationNumbers.length > 0) {
            this.getParentBuildings();
        } else if (!this.haveaParent && this.corporationNumbers.length > 1) {
            this.buildings = JSON.parse(JSON.stringify(this.ds.multiselectBuildings));
        }

        if (eventType == 'deselect')
            this.ds.selectedItemData.buildings = this.ds.selectedItemData.buildings.filter(b => b.corporationNumber != event.id);
        else if (eventType == 'deselectAll')
            this.ds.selectedItemData.buildings = [];

        if (this.buildings.length === 1 && this.ds.selectedItemData && this.ds.selectedItemData.corporationNumbers.length)
            this.ds.selectedItemData.buildings = JSON.parse(JSON.stringify(this.buildings));

        if (this.ds.selectedItemData && this.ds.selectedItemData.corporationNumbers && !this.ds.selectedItemData.corporationNumbers.length) {
            this.ds.selectedItemData.buildings = [];
        }
    }

    getParentBuildings() {
        const parentBuildings = this.ds.getParentBuildings();

        if (!parentBuildings.length) return;

        this.buildings = [];

        if (this.ds.selectedItemData) {
            this.ds.selectedItemData.buildings = [];
        }

        if (!this.data.corporationNumbers.length) return;

        parentBuildings.map(building => {
            this.buildings.push({
                ...building,
                itemName: building.name,
            });
        });
    }

    setDataBuildings() {
        if (this.ds.selectedItemData && this.ds.selectedItemData.corporationNumbers.length && this.buildings.length === 1) {
            this.ds.selectedItemData.buildings = JSON.parse(JSON.stringify(this.buildings));
        }
    }

    getCorporationNumberList() {
        this.corporationNumbers = [];
        this.corporationNumbers = this.ds.corporations.map(item => ({
            ...item,
            itemName: item.name,
            disabled: item.disabled
        }));
        const parentCorporations = this.ds.getParentCorporations(this.corporationNumbers);
        this.data.corporationNumbers = parentCorporations && parentCorporations.length > 0 ? parentCorporations : [];
        if ((!parentCorporations || parentCorporations.length < 1) && this.corporationNumbers.length === 1) {
            this.data.corporationNumbers = JSON.parse(JSON.stringify(this.corporationNumbers));
            this.getBuildingsForSelectedCorporations();
        }
        if (parentCorporations.length) {
            this.haveaParent = true;
            this.corporationNumbers = this.corporationNumbers.filter(item => {
                let hasMatchedCorporation = false;
                parentCorporations.forEach(element => {
                    if (String(item.id) === String(element.id)) {
                        hasMatchedCorporation = true;
                    }
                });
                return hasMatchedCorporation;
            });
            this.getParentBuildings();
            this.setDataBuildings();
        }
        if ((!parentCorporations || parentCorporations.length == 0) && this.corporationNumbers.length > 1) {
            this.buildings = JSON.parse(JSON.stringify(this.ds.multiselectBuildings));
        }

        this.isCorporationLoading = false;
    }

    public editOnCorporationsAndBuildings() {
        if (this.ds.selectedItemData.isCanEdit) {
            this.ds.formFields.corporations = true;
            this.ds.formFields.buildings = true;
            this.ds.copyObject.corporationNumbers = JSON.parse(JSON.stringify(this.ds.selectedItemData.corporationNumbers));
            this.ds.copyObject.buildings = JSON.parse(JSON.stringify(this.ds.selectedItemData.buildings));
        }
    }

    public editOffCorporationsAndBuildings() {
        if (this.ds.selectedItemData.isCanEdit) {
            this.ds.formFields.corporations = false;
            this.ds.formFields.buildings = false;
            this.ds.selectedItemData.corporationNumbers = JSON.parse(JSON.stringify(this.ds.copyObject.corporationNumbers));
            this.ds.selectedItemData.buildings = JSON.parse(JSON.stringify(this.ds.copyObject.buildings));
        }
    }

    public onClick(event): void {
        switch (event) {
            case 'show': {
                this.showDocument(this.ds.selectedItemData);
                break;
            }
            case 'remove': {
                this.remove(this.ds.selectedItemData);
                break;
            }
            case 'edit-permissions': {
                this.ds.showEditPermissionModal(this.ds.selectedItemData);
                break;
            }
            case 'move': {
                this.ds.showMoveModal(this.ds.selectedItemData);
                break;
            }
            default: {
                break;
            }
        }
    }

    public remove(document: Document): void {
        swal({
                title: 'Delete ' + document.name,
                text: 'Are you sure you want to delete?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                closeOnConfirm: true
            }, () => {
                this.ds.remove(document);
            }
        );
    }

    public showDocument(document: Document, event?): void {
        if (event)
            event.stopPropagation();
        document = new Document(document);
        if (document.isImage) {
            this.ds.showImage(document);
        } else if (document.idDirectory) {
            this.ds.goTo(document.id);
        } else {
            document.show();
        }
    }

    turnEditMode(field, value) {
        if (this.ds.selectedItemData.isCanEdit)
            this.ds.formFields[field] = value;
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    saveAcceptableDates() {
        const acceptableFrom = this.acceptableFrom ? new Date(this.acceptableFrom.valueOf()) : undefined;
        const acceptableTo = this.acceptableTo ? new Date(this.acceptableTo.valueOf()) : undefined;
        this.ds.updateData({
            acceptableFrom: acceptableFrom ? acceptableFrom.toISOString() : '',
            acceptableTo: acceptableTo ? acceptableTo.toISOString() : ''
        }, 0, 0);
        this.acceptableFrom = acceptableFrom;
        this.acceptableTo = acceptableTo;
    }

    onAcceptableFromChange($event: Date) {
        if ($event) {
            const newDate = new Date($event.valueOf());
            newDate.setHours(0);
            newDate.setMinutes(0);
            newDate.setSeconds(0);
            this.ds.selectedItemData.acceptableFrom = newDate;
            if (this.acceptableTo) {
                if (newDate > this.acceptableTo) {
                    const dayInMilliseconds = 1000 * 60 * 60 * 24;
                    this.acceptableTo = new Date(newDate.getTime() + dayInMilliseconds);
                }
            }
        }
    }

    onAcceptableToChange($event: Date) {
        if ($event) {
            const newDate = new Date($event.valueOf());
            newDate.setHours(23);
            newDate.setMinutes(59);
            newDate.setSeconds(59);
            this.ds.selectedItemData.acceptableTo = newDate;
            if (this.acceptableFrom) {
                if (newDate < this.acceptableFrom) {
                    const dayInMilliseconds = 1000 * 60 * 60 * 24;
                    this.acceptableFrom = new Date(newDate.getTime() - dayInMilliseconds);
                }
            }
        }
    }

    revertAcceptableDates() {
        this.acceptableFrom = this.ds.selectedItemData.acceptableFrom ? new Date(this.ds.selectedItemData.acceptableFrom.valueOf()) : undefined;
        this.acceptableTo = this.ds.selectedItemData.acceptableTo ? new Date(this.ds.selectedItemData.acceptableTo.valueOf()) : undefined;
    }
}

class ItemObj {
    corporationNumbers: Array<any> = [];
    buildings: Array<any> = [];
    name: string = null;
    permissions: Array<any> = [];
    userGroups: Array<any> = [];
    isPublic: boolean;
}



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents-detailed-view/documents-detailed-view.component.ts